import React, { useEffect, useState } from "react";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Divider from "../ui/Divider";
import { listen } from "../hooks/Listener";
import { KBD } from "../utils/Keybindings";
import { VALIDATE } from "../utils/Validators";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { useGlobals } from "../hooks/Globals";

export default function ClerkCode(props) {

    const { signal = {}, route = "", callback = () => { }, permission = false, login = true } = props;
   
    const [init, setInit] = useState(true);
    const [id, setId] = useState(null);


    const onLogin = (_force = false) => {

        if(!id){
            return; 
        }

        let _obj = {
            clerk_code : id,
            force_match : _force
        }

        callback(id);
        return

        pubCall("employee.check", _obj, (_s, _r) => {
            if(_s){
                callback(id); 
            } else {
                if(_force){
                    showError(_r)
                }
            }
        })
    }

    const actions = [
        { key: KBD.ESCAPE, action: () => { callback(false) } },
        { key: KBD.ENTER, action: () => { onLogin(true) } },
    ]

    useEffect(() => {

      

        if(id){
            onLogin(false)
        }
 
        const cleanup = listen(route, actions, false, [KBD.ESCAPE, KBD.ENTER]);
        return cleanup;
    }, [actions, id])

      
    return (
        <>
            <div style={{ "width": "154px" }}>
                <div className="shim" /><div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Enter your ID</Label><Divider vertical />
                    <Input controlled={true} style={{"textAlign" : "center"}} onChange={(e) => setId(e)} uppercase autofocus maxLength={2} autoselect placeholder="" width={40} edit value={id} />
                </Space>
            </div>
            {/* <small><pre>{JSON.stringify(signal.value, null, 2)}</pre></small> */}
        </>
    )
}